"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteQyGroupDinner = deleteQyGroupDinner;
exports.getQyGroupDinnerDetail = getQyGroupDinnerDetail;
exports.getQyGroupDinnerPage = getQyGroupDinnerPage;
exports.saveQyGroupDinner = saveQyGroupDinner;
exports.toggleEnable = toggleEnable;
exports.updateQyGroupDinnerEnable = updateQyGroupDinnerEnable;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 企业团餐相关 API
function getQyGroupDinnerPage(params) {
  return (0, _requestPIM.default)({
    url: '/xyGroupDinnerConfig/page',
    method: 'get',
    params: params
  });
}
function getQyGroupDinnerDetail(id) {
  return (0, _requestPIM.default)({
    url: "/xyGroupDinnerConfig/".concat(id),
    method: 'get'
  });
}
function saveQyGroupDinner(data) {
  return (0, _requestPIM.default)({
    url: '/xyGroupDinnerConfig',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
function deleteQyGroupDinner(id) {
  return (0, _requestPIM.default)({
    url: '/xyGroupDinnerConfig',
    method: 'delete',
    params: {
      id: id
    }
  });
}
function updateQyGroupDinnerEnable(id, enable, type) {
  return (0, _requestPIM.default)({
    url: '/xyGroupDinnerConfig/enable',
    method: 'get',
    params: {
      id: id,
      enable: enable,
      type: type
    }
  });
}

// 快捷切换活动启用状态
function toggleEnable(id, enabled) {
  return (0, _requestPIM.default)({
    url: '/xyGroupDinnerConfig/toggleEnable',
    method: 'put',
    params: {
      id: id,
      enabled: enabled
    }
  });
}